import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SystemLogo: "[Load System Logo] Action",
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  roles: [],
  systemLogo: undefined,
};

export const reducer = persistReducer(
  { storage, key: "Auth_user", whitelist: ["user", "authToken", "roles"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken, user, roles } = action.payload;
        return { authToken, user, roles };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.SystemLogo: {
        const { system_logo } = action.payload;
        return { ...state, SystemLogo: system_logo };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken, user, roles) => ({
    type: actionTypes.Login,
    payload: { authToken, user, roles },
  }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => {
    localStorage.clear();
    return { type: actionTypes.Logout };
  },
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  loadSystemLogo: (logoUrl) => ({
    type: actionTypes.SystemLogo,
    payload: { system_logo: logoUrl },
  }),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  // yield takeLatest(actionTypes.UserRequested, function* userRequested() {
  //   const { data: user } = yield getUserByToken();

  //   yield put(actions.fulfillUser(user));
  // });
}
